import React, { Component } from 'react'
import { connect } from 'react-redux'

import Tilt from '../../node_modules/react-tilt/dist/tilt.js'
import { Alert } from '@blueprintjs/core'

import PlayerToken from './PlayerToken' 
import { setGameState } from '../actions/playerActions'

var ReactGridLayout = require('react-grid-layout')
var classNames = require('classnames')
var axios = require('axios')

/*const API_BASE_URL = "https://en605401.jamalmahboob.com:5000"
const dev_API_BASE_URL = "http://10.0.0.29:5000"*/

class GameSpace extends Component {
    constructor(props) {
        super(props)
    }

    componentWillReceiveProps(nextProps) {
    }

    componentDidMount() {
        // Start long polling because time is of the essence and bad ideas still work well...
        this.longPoll = setInterval(
            () => axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game', 'api/game'))
                .then( (response) => {
                    this.props.dispatch( setGameState(response.data) )
                }),
            5000
        )
    }

    shouldComponentUpdate(nextState, nextProps) {
        return true
    }

    endGame = () => {
        window.location.href = process.env.REACT_APP_HOME
    }

    render() {
        let layout = []
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 5; j++) {
                let smushed = i.toString() + j.toString()
                let activePlayers = []
                for (let player in this.props.players) {
                    let _player = this.props.players[player]
                    let _position = _player.position[0].toString() + _player.position[1].toString()
                    if (_position === smushed) {
                        activePlayers.push(
                            <PlayerToken playerJSON={_player} player={player}/> 
                        )
                    }
                }
                layout.push({
                    i: i.toString() + j.toString(),
                    x: i,
                    y: j,
                    w: 1,
                    h: 1,
                    static: true,
                    edge: i === 0 | i === 4 | j === 0 | j === 4 ? true : false,
                    blocked: smushed === '11' | smushed === '13' | smushed === '31' | smushed === '33' ? true : false,
                    room: i % 2 === 0 && j % 2 === 0 ? true : false,
                    corner: smushed === '00' | smushed === '04' | smushed === '40' | smushed === '44' ? true : false,
                    horihall: i % 2 === 1  && j % 2 === 0 ? true : false, 
                    vertihall: i % 2 === 0 && j % 2 === 1 ? true : false,
                    topleft: i === 0 && j === 0 ? true : false,
                    topright: i === 4 && j === 0 ? true : false,
                    bottomleft: i === 0 && j === 4 ? true : false,
                    bottomright: i === 4 && j === 4 ? true : false,
                    activePlayers
                })
            }
        }

        let items = Object.entries(layout).map(
            ([key, value]) => {

                let classes = classNames({
                    tile: true,
                    edge: value.edge ? true : false,
                    room: value.room ? true : false,
                    spacer: value.blocked ? true : false,
                    horihall: value.horihall ? true : false,
                    vertihall: value.vertihall ? true : false,
                    topleft: value.topleft,
                    topright: value.topright,
                    bottomleft: value.bottomleft,
                    bottomright: value.bottomright,
                })

                let _key = value.x.toString() + value.y.toString()

                /*return (
                    <Tilt className="Tilt" key={_key} options={{scale: 1.25, perspective: 950}}>
                        <div className={classes} key={_key}>
                            { value.i }
                            { value.edge && 'Edge' }
                            { value.blocked && 'Spacer' }
                            { value.room && 'Room' }
                            { value.corner && 'Corner' }
                            { (value.horihall || value.vertihall) && 'Hallway' }
                            { value.activePlayers && value.activePlayers }
                        </div>
                    </Tilt>
                )*/
                return (
                    <Tilt className="Tilt" key={_key} options={{scale: 1.25, perspective: 950}}>
                        <div className={classes} key={_key}>
                            { value.i === '00' && 'Kitchen' }
                            { value.i === '02' && 'Ballroom' }
                            { value.i === '04' && 'Conservatory' }
                            { value.i === '20' && 'Dining Room' }
                            { value.i === '22' && 'Billiard Room' }
                            { value.i === '24' && 'Library' }
                            { value.i === '40' && 'Lounge' }
                            { value.i === '42' && 'Hall' }
                            { value.i === '44' && 'Study' }
                            { value.activePlayers && value.activePlayers }
                        </div>
                    </Tilt>
                )
            }
        )

        return (
            <div>
                <ReactGridLayout 
                    className="layout" 
                    layout={layout} 
                    cols={5} 
                    rowHeight={960 / 5} 
                    width={960} 
                    useCSSTransforms={false}
                >
                    {items}
                </ReactGridLayout>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        players: state.players,
        winner: state.winner
    }
}

export default connect(mapStateToProps)(GameSpace)



// WEBPACK FOOTER //
// ./src/components/GameSpace.jsx